export const withSeparator = (number: any) => {
    if (number !== 0 && number !== undefined && number !== null) {
        number = number.toString().replace(/,/g, '');
    }
    if (number !== null && !isNaN(number)) {
        const parts = number.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
    } else {
        return '-';
    }
};
